module.exports = __webpack_public_path__ + "f89fe8b8077948e2e200353031f8ebc8.svg";